const gradientColorList = {
  orange: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#fe9365"],
      [1, "#feb798"],
    ],
  },
  red: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#fe5d70"],
      [1, "#fe909d"],
    ],
  },
  purple: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#8d77df"],
      [1, "#ae9ee8"],
    ],
  },
  olivedrab: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#4da183"],
      [1, "#6cbc90"],
    ],
  },
  green: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#0ac282"],
      [1, "#0df3a3"],
    ],
  },
  yellow: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#ffd700"],
      [1, "#ffec81"],
    ],
  },
  turquoise: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#01a9ac"],
      [1, "#01dbdf"],
    ],
  },
  blue: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#0a6fec"],
      [1, "#23b8f7"],
    ],
  },
  darkblue: {
    linearGradient: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    },
    stops: [
      [0, "#1c4293"],
      [1, "#0189e3"],
    ],
  },
};

export default {
  gradientColorList,
};
